import { configureStore } from "@reduxjs/toolkit";
// import loggedInReducer from "./components/Features/testing/testing.js";
import { counterReducer, testingReducer } from "./redux/testingSlices";
// import * as All from "./redux/testingSlices";
// import { userReducer } from "./redux/userSlices";
// import { authReducer } from "./redux/authSlice";
import { authReducer } from "./redux/authSlice";
import { protectedDataReducer } from "./redux/protectedDataSlice";

export default configureStore({
  reducer: {
    counter: counterReducer,
    testing: testingReducer,
    protectedData: protectedDataReducer,
    auth: authReducer,
  },
});
